import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "AID_LICS",
  title: defineMessage({
    id: "fig.finance.AID_LICS.title",
    defaultMessage: `Share of aid to education going to low income countries`,
  }),
  caption: defineMessage({
    id: "fig.finance.AID_LICS.caption",
    defaultMessage: `Less and less education aid is going to low income countries.`,
  }),
  source: defineMessage({
    id: "fig.finance.AID_LICS.source",
    defaultMessage: `GEM Report team analysis based on OECD CRS`,
  }),
};
